import algoliasearch from 'algoliasearch';

export const makeSearchClientWithKey = (apiKey: string, appId: string) =>
  algoliasearch(appId, apiKey);

export const defaultAlgoliaContext = (
  apiKey: string,
  appId: string,
  index: string
) => ({
  indexes: {
    main: index
  },
  searchClient: makeSearchClientWithKey(apiKey, appId)
});
